<div class="wrapper">
  <div class="white-container not-found">
    <h1>Tražena stranica nije pronađena!</h1>
    <a [href]="redirectUrl">Povratak na početnu stranicu</a>
  </div>
</div>